/* Kalma Volt: deslizador antes/después, cuenta atrás a fecha fija y carrusel de fotos. */
(function () {
  'use strict';

  document.querySelectorAll('[data-kc-compare]').forEach(function (el) {
    var before = el.querySelector('.kc-compare__before');
    var handle = el.querySelector('.kc-compare__handle');
    if (!before || !handle) return;
    var pct = 50, dragging = false;
    function set(p) {
      pct = Math.max(2, Math.min(98, p));
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      el.setAttribute('aria-valuenow', String(Math.round(pct)));
    }
    function fromEvent(e) {
      var r = el.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    }
    el.addEventListener('pointerdown', function (e) { dragging = true; if (el.setPointerCapture) el.setPointerCapture(e.pointerId); fromEvent(e); });
    el.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    el.addEventListener('pointerup', function () { dragging = false; });
    el.addEventListener('pointercancel', function () { dragging = false; });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { set(pct - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(pct + 5); e.preventDefault(); }
    });
    set(50);
  });

  /* Cuenta atrás hasta una fecha fija (segundos Unix en data-kv-countdown).
     No se reinicia: al llegar a cero, el bloque se oculta. */
  document.querySelectorAll('[data-kv-countdown]').forEach(function (el) {
    var end = parseInt(el.getAttribute('data-kv-countdown'), 10) * 1000;
    var clock = el.querySelector('[data-kv-countdown-clock]');
    if (!end || !clock) return;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    (function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.hidden = true; return; }
      var h = Math.floor(d / 3600000), m = Math.floor((d % 3600000) / 60000), s = Math.floor((d % 60000) / 1000);
      clock.textContent = (h >= 24 ? Math.floor(h / 24) + 'd ' + pad(h % 24) : pad(h)) + ':' + pad(m) + ':' + pad(s);
      setTimeout(tick, 1000);
    })();
  });

  /* Carrusel de fotos en uso */
  document.querySelectorAll('[data-kv-ugc]').forEach(function (track) {
    var wrap = track.parentElement;
    var step = function () { var s = track.querySelector('.kv-ugc__slide'); return s ? s.getBoundingClientRect().width + 16 : 300; };
    var prev = wrap.querySelector('[data-kv-ugc-prev]');
    var next = wrap.querySelector('[data-kv-ugc-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();
